import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setTokenExp(token, seconds) {
  const inFifteenMinutes = new Date(new Date().getTime() + seconds * 1000)
  return Cookies.set(TokenKey, token, { expires: inFifteenMinutes })
}
